import { PreflightStatus } from "hoxton-shared/enums/creativex";
import { BannerQaCommentedOnBy, BannerQaStatus, BannerQaUserStatus } from "@/enums/banners";

export const PublishedStatusFilter = {
    All: "ALL",
    NotPublished: "n",
    NotPublishedToDoubleClick: "npdc",
    NotPublishedToFlashtalking: "npf",
    NotPublishedToOpenDC: "npodc",
    Published: "p",
    PublishedToDoubleClick: "pdc",
    PublishedToFlashtalking: "pf",
    PublishedToOpenDC: "podc"
} as const;

export const CreativeXScoreFilters = {
    All: "ALL",
    OverThreshold: "OVER-[THRESHOLD]",
    UnderThreshold: "UNDER-[THRESHOLD]"
} as const;

export const PreflightStatusFilters = {
    All: "ALL",
    NotSent: PreflightStatus.NOT_SENT,
    Processing: PreflightStatus.PROCESSING,
    Completed: PreflightStatus.COMPLETED,
    Error: PreflightStatus.ERROR
} as const;

export const BannerQaStatusFilter = {
    All: "ALL",
    ...BannerQaStatus
} as const;

export const BannerQaCommentedOnByFilter = {
    All: "ALL",
    ...BannerQaCommentedOnBy
} as const;

export const BannerQaUserStatusFilter = {
    All: "ALL",
    ...BannerQaUserStatus
} as const;

export const BannerQaCommentedOnByLabel = {
    [BannerQaCommentedOnBy.Me]: "Me",
    [BannerQaCommentedOnBy.Any]: "Everybody",
    [BannerQaCommentedOnBy.None]: "None"
} as const;

export const BannerQaStatusLabel = {
    [BannerQaStatus.Draft]: "Draft",
    [BannerQaStatus.InReview]: "In review",
    [BannerQaStatus.Approved]: "Fully reviewed",
    [BannerQaStatus.Rejected]: "Changes required"
} as const;

export const BannerQaUserStatusLabel = {
    [BannerQaUserStatus.INone]: "Me",
    [BannerQaUserStatus.IApproved]: "Me",
    [BannerQaUserStatus.IRejected]: "Me",
    [BannerQaUserStatus.None]: "Everybody",
    [BannerQaUserStatus.Approved]: "Everybody",
    [BannerQaUserStatus.Rejected]: "Everybody"
} as const;

export const BannerQaCommentedOnByFilterLabel = {
    [BannerQaCommentedOnByFilter.All]: "All",
    ...BannerQaCommentedOnByLabel
} as const;

export const BannerQaStatusFilterLabel = {
    [BannerQaStatusFilter.All]: "All",
    ...BannerQaStatusLabel
} as const;

export const BannerQaUserStatusFilterLabel = {
    [BannerQaUserStatusFilter.All]: "All",
    ...BannerQaUserStatusLabel
} as const;
